<template>
  <div class="patient-area d-flex flex-column min-vh-100">
    <div id="preloader" v-show="loading">
      <div id="status">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
    </div>

    <header id="topnav" class="defaultscroll sticky nav-sticky">
      <div class="container">
        <a class="logo" href="https://ubbimed.com.br">
          <img :src="require('@/assets/images/logo_ubbi.png')" class="logo-light-mode" alt="Ubbimed">
        </a>

        <div class="buy-button">
          <ThemeToggle />
        </div>

        <div class="menu-extras">
          <div class="menu-item">
            <a class="navbar-toggle" id="isToggle" @click="toggleMenu">
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
          </div>
        </div>

        <div id="navigation">
          <ul class="navigation-menu">
            <li>
              <router-link to="/" class="sub-menu-item" @click="toggleMenu">Agendar</router-link>
            </li>
            <li>
              <a href="https://ubbimed.com.br/index.html#us" class="sub-menu-item" @click="toggleMenu">Quem somos</a>
            </li>
            <li>
              <a href="https://ubbimed.com.br/index.html#how_works" class="sub-menu-item" @click="toggleMenu">Como funciona</a>
            </li>
            <li>
              <a :href="urlProfessional" class="sub-menu-item" @click="toggleMenu">Para Profissionais</a>
            </li>
          </ul>

          <div class="d-lg-none mt-3">
            <PatientNav @navigate="toggleMenu" @logout="logout" />
          </div>
        </div>
      </div>
    </header>

    <section class="section-two bg-light">
      <div class="container">
        <p class="patient-hello">Olá, {{ userAuth?.first_name }}</p>
        <div class="row">
          <div class="col-lg-3 d-none d-lg-block">
            <PatientNav @logout="logout" />
          </div>

          <div class="col-lg-9">
            <router-view :key="$route.fullPath"/>
          </div>
        </div>
      </div>
    </section>

    <footer class="footer footer-bar" style="margin-top: auto;">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-sm-6">
            <div class="text-sm-start">
              <p class="mb-0">
                © {{ new Date().getFullYear() }} Ubbimed. Feito em Araras.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <BannerModal />
  </div>
</template>

<script>
import {initTemplate, toggleMenu} from "@/assets/js/app";
import Swal from "sweetalert2";
import BannerModal from "./BannerModal.vue";
import PatientNav from "./PatientNav.vue";
import ThemeToggle from "./ThemeToggle.vue";

export default {
  name: "Patient",
  components: {
    BannerModal,
    PatientNav,
    ThemeToggle,
  },
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    this.loading = false;
    initTemplate();
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
    urlProfessional() {
      return this.$store.state.urlProfessional;
    },
  },
  methods: {
    toggleMenu: toggleMenu,
    logout() {
      Swal.fire({
        title: 'Sair',
        text: "Tem certeza que deseja sair?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#780f5a',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, Sair!',
        cancelButtonText: "Não"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('auth/logout').then(() => {
            this.$router.push('/');
          });
        }
      })
    },
  },
}
</script>
